export type CodeBlockProps = { lang: string; withLineNumbers?: boolean; code: string };

export type BasePrismLanguage =
  | 'markup'
  | 'jsx'
  | 'tsx'
  | 'swift'
  | 'kotlin'
  | 'objectivec'
  | 'js-extras'
  | 'reason'
  | 'rust'
  | 'graphql'
  | 'yaml'
  | 'go'
  | 'cpp'
  | 'markdown'
  | 'python'
  | 'json';
export type ExternalPrismLanguage = 'bash' | 'http';

export type PrismLangs = BasePrismLanguage | ExternalPrismLanguage;

export type PygmentsLang =
  | 'bash'
  | 'c'
  | 'c++'
  | 'go'
  | 'html'
  | 'http'
  | 'java'
  | 'javascript'
  | 'json'
  | 'jsx'
  | 'kotlin'
  | 'markdown'
  | 'objective-c'
  | 'python'
  | 'rust'
  | 'swift'
  | 'tsx'
  | 'yaml';

export const PYGMENTS_TO_PRISM: Record<PygmentsLang, PrismLangs> = {
  bash: 'bash',
  c: 'cpp',
  'c++': 'cpp',
  go: 'go',
  html: 'markup',
  http: 'http',
  java: 'kotlin',
  javascript: 'jsx',
  json: 'json',
  jsx: 'jsx',
  kotlin: 'kotlin',
  markdown: 'markdown',
  'objective-c': 'objectivec',
  python: 'python',
  rust: 'rust',
  swift: 'swift',
  tsx: 'tsx',
  yaml: 'yaml',
};
